import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class HttpCancelService {
  private cancelPending$ = new Subject<void>();

  onCancelPending$ = this.cancelPending$.asObservable();

  cancelRequests() {
    this.cancelPending$.next();
  }
}
